import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import Input from '@/components/v4/Input';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const ApprovalCodeCode = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    console.log(errors)
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.code && touched.code}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Code <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field
                    as={NameField}
                    id="code"
                    name="code"
                    data-walkthroughid={walkthroughIds.createMode.ufCodeInput}
                    validate={value => {
                        if (!value) return 'Code is required';
                        if (value.length < 6) return 'Code must be at least 6 characters';
                        return undefined;
                    }}
                    error={errors.code}
                    touched={touched.code}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the approval code. Minimum 6 characters."
                        ariaLabel="approval-code-code-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodeCode;